import { useApplicationContext } from '../modules/context/ApplicationContext/ApplicationContext';
import { Brand } from '../modules/context/ApplicationContext/applicationContext.types';
import { useModalState } from './useModalState';

export const useHandleBrandContext = () => {
  const brandModal = useModalState();
  const { state, changeBrand, isStore } = useApplicationContext();

  const selectBrand = (brand: Brand) => {
    changeBrand(brand);
  };

  return {
    isBrandContextValid: !(isStore && !state.brand),
    brandModal,
    selectBrand,
  };
};
